

/**
 * Generates a URL for a placeholder image.
 * @param width The width of the placeholder image.
 * @param height The height of the placeholder image.
 * @param color The background color of the placeholder image (hex without #).
 * @param textColor The text color of the placeholder image (hex without #).
 * @returns A URL string for the placeholder image.
 */
export const generatePlaceholderImage = (
  width: number,
  height: number,
  color: string = 'e5e7eb', // neutral-200
  textColor: string = '9ca3af' // neutral-400
): string => {
  return `https://via.placeholder.com/${width}x${height}/${color}/${textColor}?text=No+Image`;
};